<template>
  <router-view />
</template>

<script>
export default {
  name: "list"
};
</script>
